/**
 * Public marketing pages scroll the browser document (html/body), not an inner ScrollView,
 * because the RN ScrollView grows to full content height on web.
 */

import type { RefObject } from 'react'

export function scrollWebWindowToElement(
  element: HTMLElement | null | undefined,
  stickyTopOffsetPx: number,
): void {
  if (typeof window === 'undefined' || !element) return
  const rect = element.getBoundingClientRect()
  const top = rect.top + window.scrollY - stickyTopOffsetPx
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
}

export function scrollWebWindowToTop(): void {
  if (typeof window === 'undefined') return
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/** react-native-web forwards View refs to the host DOM node. */
export function getViewWebHostElement(ref: RefObject<unknown>): HTMLElement | null {
  const n = ref.current as unknown
  if (n == null || typeof window === 'undefined') return null
  if (n instanceof HTMLElement) return n
  return null
}
